import React from 'react';
import {withRouter} from "react-router";

import './Footer.css';

const show = () => window.location.pathname !== '/manage';

const Footer = ({history}) => (show() && <div className="page-footer bg-grey">
  <div className="container row">
    <div className="col-12 col-md-4 text-start mt-5 order-last order-md-first">
      <img
        className="home-header-logo"
        src="/assets/logo-white.png"
        alt="tiny.host"
        onClick={() => history.push('/')}
      />
      <div className="white op-8 mt-2">Made with 💜 in London 💂‍♂️</div>
      <div className="white mt-5 op-7">
        <div className="font-small mb-2">Built upon</div>
        <img
          className="home-header-logo"
          src="/assets/icons/aws.png"
          alt="Amazon Web Services"
        />
      </div>
      <div className="font-small white mt-5 op-7">© Tiiny Host {new Date().getFullYear()}</div>
      <div className="text-sm grey mt-3">
        Tiiny Labs Ltd. is a company registered in England and Wales with company number 12977077
      </div>
    </div>
    <div className="col-12 col-md-3 mt-5">
      <h3 className="bold-white">Use Cases</h3>
      <ul className="footer-list">
        <li><a href="https://tiiny.host/free-static-website-hosting">Free static website hosting</a></li>
        <li><a href="https://tiiny.host/web-hosting-for-small-business">Web hosting for small business</a></li>
        <li><a href="https://tiiny.host/web-hosting-for-students">Web hosting for students</a></li>
        <li><a href="https://tiiny.host/web-hosting-free-sites">Web hosting free sites</a></li>
        <li><a href="https://tiiny.host/zip-site-web-hosting">Zip file hosting</a></li>
        <li><a href="https://tiiny.host/marzipano-vr-host">Marzipano vr host</a></li>
        <li><a href="https://tiiny.host/host-html-file">Host html file</a></li>
        <li><a href="https://tiiny.host/how-to-host-your-own-website">How to host your own website</a></li>
        <li><a href="https://tiiny.host/pdf-upload">PDF upload</a></li>
        <li className="pt-3"><a href="https://tiiny.host/use-case">Other use cases</a></li>
        <li><a href="https://tiiny.host/host">Host...</a></li>
      </ul>
    </div>
    <div className="col-12 col-md-2 mt-5">
      <h3 className="bold-white">Support</h3>
      <ul className="footer-list">
        <li><a href="https://tiiny.host/documentation" target="_blank">Documentation</a></li>
        <li onClick={() => window.$crisp.push(['do', 'chat:open'])}>Live Chat</li>
        <li onClick={() => history.push('/help')}>FAQs</li>
        <li onClick={() => history.push('/help')}>Contact</li>
      </ul>
    </div>
    <div className="col-12 col-md-3 mt-5 text-start">
      <h3 className="bold-white">Company</h3>
      <ul className="footer-list mb-3">
        <li onClick={() => history.push('/affiliates')}>Affiliate program</li>
        <li onClick={() => history.push('/pricing')}>Pricing</li>
        <li><a href="https://tiiny.host/blog">Our Blog</a></li>
        <li onClick={() => history.push('/report-site')}>Report abuse</li>
        <li><a href="http://tiiny.host/termsofservice.html">Terms & Conditions</a></li>
        <li><a href="http://tiiny.host/privacypolicy.html">Privacy Policy</a></li>
      </ul>
      <div className="flex align-items-center">
        <a href="https://twitter.com/tiinyhost" target="_blank">
          <img alt="Twitter" src="assets/icons/twitter.png" height="20"/>
        </a>
        <a className="ms-3" href="https://www.youtube.com/channel/UCmcesQ2I9hvEQqhI4CU6wBA" target="_blank">
          <img alt="YouTube" src="assets/icons/youtube.png" height="20"/>
        </a>
        <a className="ms-3" href="https://www.linkedin.com/company/tiiny-host" target="_blank">
          <img alt="LinkedIn" src="assets/icons/linkedin.png" height="18"/>
        </a>
      </div>
    </div>
  </div>
</div>);

export default withRouter(Footer);
